import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { Grid, Tabs, DataTable, FranchiseSingleDashboard, makeStyles, Button, ViewColumnIcon, ViewListIcon, Typography, SMCard as Card, Paper } from "../../../../";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import { Link } from "react-router-dom";
import { FranchiseContacts } from "../../../..";
import { InvoiceList } from "../../Billing/List";
var useStyles = makeStyles(function (theme) {
  return {
    charts: {
      display: "flex",
      "justify-content": "space-between",
      padding: "25px",
      "flex-direction": "column"
    },
    contact: {
      background: "#ededed45",
      borderRadius: "4px"
    },
    mb30: {
      "margin-bottom": "30px"
    },
    edit: {
      color: theme.palette.pending.main
    },
    columnsContainer: {
      display: "flex",
      "justify-content": "space-between"
    },
    column: {
      display: "flex",
      flexDirection: "column",
      "align-items": "center",
      "min-height": "300px"
    },
    title: {
      "text-align": "center",
      "font-weight": "bold",
      background: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      width: "260px",
      "border-radius": "4px 4px 0px 0px",
      padding: "5px 15px"
    },
    content: {
      width: "260px",
      background: "#7D7D7D",
      padding: "15px"
    },
    layoutOptions: {
      display: "flex",
      "justify-content": "flex-end",
      width: "97%",
      padding: "10px 0px"
    }
  };
});

var FranchiseSingle = function FranchiseSingle(_ref) {
  var franchise = _ref.franchise,
      contacts = _ref.contacts,
      opportunities = _ref.opportunities,
      projects = _ref.projects,
      editFranchise = _ref.editFranchise,
      deleteFranchise = _ref.deleteFranchise,
      deleteUser = _ref.deleteUser,
      language = _ref.language,
      editUser = _ref.editUser,
      createUser = _ref.createUser,
      viewTask = _ref.viewTask,
      options = _ref.options,
      columns = _ref.columns,
      title = _ref.title,
      handleCreateContact = _ref.handleCreateContact,
      handleImportContacts = _ref.handleImportContacts,
      taxes = _ref.taxes,
      getInvoicesData = _ref.getInvoicesData,
      invoice_pdf = _ref.invoice_pdf,
      getInvoicePdf = _ref.getInvoicePdf,
      year = _ref.year,
      handleChangeYear = _ref.handleChangeYear,
      handleSelectYears = _ref.handleSelectYears,
      totals = _ref.totals,
      props = _objectWithoutProperties(_ref, ["franchise", "contacts", "opportunities", "projects", "editFranchise", "deleteFranchise", "deleteUser", "language", "editUser", "createUser", "viewTask", "options", "columns", "title", "handleCreateContact", "handleImportContacts", "taxes", "getInvoicesData", "invoice_pdf", "getInvoicePdf", "year", "handleChangeYear", "handleSelectYears", "totals"]);

  // console.log("FranchisesSingle franchise ", franchise);
  var classes = useStyles();

  var _useState = useState("invoices"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tasks = _useState4[0],
      setTasks = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      openOpportunities = _useState6[0],
      setopenOpportunities = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      invoices = _useState8[0],
      setInvoices = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      billingDashboard = _useState10[0],
      setBillingDashboard = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showBoard = _useState12[0],
      setShowBoard = _useState12[1];

  var _useState13 = useState(true),
      _useState14 = _slicedToArray(_useState13, 2),
      showDataTable = _useState14[0],
      setShowDataTable = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      board = _useState16[0],
      setBoard = _useState16[1];

  useEffect(function () {
    getInvoicesData().then(function (response) {
      setInvoices(_toConsumableArray(response.data.invoices));
      setBillingDashboard(_objectSpread(_objectSpread({}, response.data.dashboard), totals));
    });
  }, []);
  useEffect(function () {
    setBillingDashboard(_objectSpread(_objectSpread({}, billingDashboard), totals));
  }, [totals]);
  useEffect(function () {// console.log("year changed in franchise", year);
  }, [year]);
  var typeContacts = {
    client: "Client",
    person: "Person of contact"
  };
  var columnsContact = {
    title: "Contacts",
    columns: [{
      label: "id",
      name: "_id",
      options: {
        display: false,
        filter: false
      }
    }, {
      label: "Name",
      name: "name",
      options: {
        filter: false
      }
    }, {
      label: "Type",
      name: "type",
      options: {
        filter: true,
        filterType: "checkbox",
        customFilterListOptions: {
          render: function render(v) {
            return "Type".concat(" ", v, "}");
          }
        },
        filterOptions: {
          names: Object.values(typeContacts),
          logic: function logic(type, filterVal) {
            var show = filterVal.indexOf("Client") >= 0 && type === "client" || filterVal.indexOf("Person of contact") >= 0 && type === "person";
            return !show;
          }
        },
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(Typography, {
            variant: "body2",
            gutterBottom: true
          }, typeContacts[tableMeta.rowData[2]] || "no definido");
        }
      }
    }, {
      label: "Email",
      name: "email",
      options: {
        filter: false
      }
    }, {
      label: "Telephone",
      name: "telephone",
      options: {
        filter: false
      }
    }, {
      label: "City",
      name: "city",
      options: {
        filter: false
      }
    }, {
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          if (tableMeta.rowData[2] === "client") {
            return /*#__PURE__*/React.createElement(Link, {
              to: "/franchises/" + franchise._id + "/contacts/" + tableMeta.rowData[0] + "/view",
              style: {
                color: "#fff"
              }
            }, /*#__PURE__*/React.createElement(RemoveRedEye, null));
          }
        }
      }
    }],
    options: options
  };
  var columnsImportContact = {
    title: "Contacts",
    columns: [{
      name: "name",
      label: "Name"
    }, {
      name: "billingInfo_name",
      label: "Billing Name"
    }, {
      name: "city",
      label: "City"
    }, {
      name: "email",
      label: "Email"
    }, {
      name: "web",
      label: "Web"
    }, {
      name: "telephone",
      label: "Telephone"
    }, {
      name: "clientTypeLabel",
      label: "Client Type"
    }, {
      name: "people_0_name",
      label: "Person contact name"
    }, {
      name: "people_0_email",
      label: "Person contact email"
    }, {
      name: "people_0_telephone",
      label: "Person contact telephone"
    }, {
      name: "people_0_job",
      label: "Person contact job"
    }],
    options: options
  };

  var createBoard = function createBoard(openOpportunities) {
    var temp = [[], [], [], []];
    openOpportunities && openOpportunities.forEach(function (opportunity) {
      return opportunity.statusSells !== undefined && temp[opportunity.statusSells] !== undefined && temp[opportunity.statusSells].push(opportunity);
    });
    return temp;
  };

  useEffect(function () {
    openOpportunities && setBoard(createBoard(openOpportunities));
  }, [showBoard]);

  var handleShowBoard = function handleShowBoard() {
    if (!showBoard) {
      setShowBoard(true);
      setShowDataTable(false);
    }
  };

  var handleShowDataTable = function handleShowDataTable() {
    if (!showDataTable) {
      setShowBoard(false);
      setShowDataTable(true);
    }
  };

  var createTaskArray = function createTaskArray(opportunities) {
    var pendingTasks = [];
    opportunities.forEach(function (opportunity) {
      opportunity.tasks.forEach(function (task) {
        return pendingTasks.push(_objectSpread(_objectSpread({}, task), {}, {
          project: opportunity._id,
          person_of_contact: task.contact.name ? task.contact.name : ""
        }));
      });
    });
    return pendingTasks;
  };

  useEffect(function () {
    setopenOpportunities(opportunities.filter(function (opp) {
      return opp.statusSells < 6;
    }));
    setTasks(createTaskArray(opportunities));
  }, [opportunities]);

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var statusSell = ["Lead", "Proposal", "Offer", "On hold"];

  var contentTabHandler = function contentTabHandler(value) {
    // console.log('translationen contentTabHandler', translation.datatables)
    switch (value) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(FranchiseSingleDashboard, {
          franchise: franchise,
          editFranchise: editFranchise,
          deleteFranchise: deleteFranchise,
          createUser: createUser,
          editUser: editUser,
          deleteUser: deleteUser,
          opportunities: openOpportunities,
          projects: projects,
          taxes: taxes
        });

      case "crm":
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 12,
          className: classes.charts
        }, /*#__PURE__*/React.createElement(Grid, {
          className: classes.layoutOptions
        }, /*#__PURE__*/React.createElement(Button, {
          variant: "text",
          "data-cy": "view-columns",
          onClick: handleShowBoard
        }, /*#__PURE__*/React.createElement(ViewColumnIcon, {
          fontSize: "default",
          color: showBoard ? "primary" : "inherit"
        })), /*#__PURE__*/React.createElement(Button, {
          variant: "text",
          "data-cy": "view-datatable",
          onClick: handleShowDataTable
        }, /*#__PURE__*/React.createElement(ViewListIcon, {
          fontSize: "default",
          color: showDataTable ? "primary" : "inherit"
        }))), showDataTable && [/*#__PURE__*/React.createElement(DataTable, {
          type: "opportunities",
          className: classes.mb30,
          data: openOpportunities,
          options: options,
          columns: columns[0],
          title: title[0]
        }), /*#__PURE__*/React.createElement(DataTable, {
          type: "tasks",
          data: tasks,
          options: options,
          columns: columns[2],
          title: title[2] // translation={translation ? translation.datatables.tasks : null}

        })], board && showBoard && /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.columnsContainer
        }, board.map(function (status, i) {
          // console.log("status", status);
          return /*#__PURE__*/React.createElement(Grid, {
            item: true,
            md: 3,
            className: classes.column
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "h6",
            className: classes.title
          }, statusSell[i]), /*#__PURE__*/React.createElement(Paper, {
            className: classes.content
          }, status.map(function (opp) {
            return /*#__PURE__*/React.createElement(Card, {
              data: opp,
              link: "/franchises/".concat(opp.franchise, "/pipeline/").concat(opp._id, "/view")
            });
          })));
        })));

      case "projects":
        return /*#__PURE__*/React.createElement(DataTable, {
          type: "projects",
          data: projects,
          options: options,
          columns: columns[1],
          title: title[1] // translation={translation ? translation.datatables.projects : null}

        });

      case "contacts":
        return /*#__PURE__*/React.createElement(FranchiseContacts, {
          data: contacts,
          columns: columnsContact,
          language: "en",
          createContact: handleCreateContact,
          importContacts: handleImportContacts,
          columnsImport: columnsImportContact
        });

      case "invoices":
        return invoices && /*#__PURE__*/React.createElement(InvoiceList, {
          isCentralFranchiseView: true,
          invoice_pdf: invoice_pdf,
          getInvoicePdf: getInvoicePdf,
          invoices: invoices,
          compareInvoices: props.compareInvoices,
          columns: columns[3],
          locale: franchise.country,
          centralUser: true,
          groupedByCategory: true // invoicesToPDF={invoicesToPDF}
          ,
          dashboard: billingDashboard,
          centralView: true,
          getFilteredInvoices: getInvoicesData,
          year: year,
          handleChangeYear: handleChangeYear,
          handleSelectYears: handleSelectYears,
          totals: totals
        });

      default:
        return /*#__PURE__*/React.createElement(DataTable, {
          type: "opportunities",
          data: openOpportunities,
          options: options,
          columns: columns[0],
          title: title[0]
        });
    }
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "standard",
    className: classes.mb30,
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: [{
      label: "Dashboard",
      value: "dashboard"
    }, // {
    //   label: "CRM",
    //   value: "crm",
    // },
    // {
    //   label: "Contacts",
    //   value: "contacts",
    // },
    // {
    //   label: "Projects",
    //   value: "projects",
    // },
    {
      label: "Invoices",
      value: "invoices"
    }]
  }), contentTabHandler(value)))];
};

export default FranchiseSingle;